export const INITIAL_CHECK_TIMEOUT_MS = 3000;
export const CONSECUTIVE_SUCCESS_THRESHOLD = 2;

// Backend sends the heartbeat every 5s (over the notifications SSE); allow 15s
// (3 missed) before considering the API-liveness feed dead.
export const SSE_HEARTBEAT_TIMEOUT_MS = 15_000;

// Missed-heartbeat ticks shown as RECONNECTING before escalating to the DOWN banner.
export const MAX_SILENT_RECONNECTS = 2;
